import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-name-fields',
  templateUrl: './name-fields.component.html',
  styleUrls: ['./name-fields.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, IonicModule, TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NameFieldsComponent),
      multi: true
    }
  ]
})
export class NameFieldsComponent implements ControlValueAccessor {
  @Input() submitted: boolean = false;

  nameForm: FormGroup = this.fb.group({
    first_name: ['', Validators.required],
    last_name: ['', Validators.required]
  });

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor(private fb: FormBuilder) {
    this.nameForm.valueChanges.subscribe(value => {
      this.onChange(value);
    });
  }

  writeValue(value: any): void {
    if (value) {
      this.nameForm.patchValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.nameForm.disable();
    } else {
      this.nameForm.enable();
    }
  }

  get firstNameControl() {
    return this.nameForm.get('first_name');
  }

  get lastNameControl() {
    return this.nameForm.get('last_name');
  }
}
